export default __webpack_public_path__ + "static/logo-cropped-05f78229171b4c8133409d13e9a3b5b3.svg";